/** @format */

import React from "react";
import { TPersonaPresenze } from "../../../../redux-modules/declarations/maps/presenzeVista";
import { iniziali } from "../format";
import { AvatarStile } from "../styles";

/** Foto della persona, o le iniziali per l'avatar predefinito (avatar null dal backend). */
export const AvatarPersona = ({
  persona,
  grande = false,
}: {
  persona: Pick<TPersonaPresenze, "nome" | "cognome" | "avatar">;
  grande?: boolean;
}): JSX.Element => (
  <AvatarStile className={grande ? "grande" : undefined} aria-hidden="true">
    {persona.avatar ? <img src={persona.avatar} alt="" /> : iniziali(persona)}
  </AvatarStile>
);
